<!-- Modal Dialog - Login/Signup

============================================= -->

<div id="main-wrapper">

    <app-header></app-header>
    <!-- Content
  ============================================= -->
    <!-- <header id="header">
        <div class="container">
            <div class="fixed-header1 d-none d-sm-block" id="headerattention">
            </div>
            <div class="header-row">
                <div class="header-column justify-content-start">
                    <div class="logo">
                        <img src="{{logo}}" alt="" width="" height="60" />
                    </div>
                </div>
            </div>
        </div>
    </header> -->
    <div id="content">
        <div class="container container bg-light shadow-md rounded p-4 mt-2 mt-2">
            <ul class="nav nav-tabs style-3" id="myTab" role="tablist">
                <li class="nav-item"> <a class="nav-link active" id="first-tab" data-toggle="tab" href="#first"
                        role="tab" aria-controls="first" aria-selected="true"
                        (click)="switchTabs('NewActivation')"><span><i class="fa fa-mobile"></i></span>{{'New
                        Activation'}}</a>
                </li>
                <li class="nav-item"><a class="nav-link" id="second-tab" data-toggle="tab" href="#second" role="tab"
                        aria-controls="second" aria-selected="false" (click)="switchTabs('RechargeBundle')"><span><i
                                class="fa fa-phone-square"></i></span>{{'Recharge Bundle'}}</a>
                </li>
            </ul>

            <div class="row">
                <div class="col" id="rechargeBill">
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="first" role="tabpanel" aria-labelledby="first-tab">
                            <div class="form-row">
                                <div class="col-md-7 col-sm-7">
                                    <!-- <div class="col-md-2 col-sm-2">&nbsp;</div> -->
                                    <div class="col-md-12 col-sm-12 row ">
                                        <div class=" col-md-6 col-sm-6  mb-2"><button class="btn btn-block btn-primary"
                                                (click)="activationPlanData('call')">Talktime, Data, SMS</button></div>
                                        <div class="col-md-6 col-sm-6  mb-2"><button class="btn btn-primary btn-block"
                                                (click)="activationPlanData('data')">Data
                                                Only </button></div>


                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-5"></div>
                            </div>
                            <div class="white row">
                                <!-- <form id="RechargeOnline" method="post" autocomplete="off"> -->
                                <div class="col-md-7 col-sm-7">
                                    <div id="ActivationPlanList" class="table-responsive-md">
                                        <table class="table table-hover border">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="text-right">Sel</th>
                                                    <th>SNo</th>
                                                    <th>Details</th>
                                                    <th>Amt</th>
                                                    <th>Voice</th>
                                                    <th>Data </th>
                                                    <th>SMS</th>
                                                    <th>Validity</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let Agent of activationlist;let i = index">
                                                    <td class="text-right red hand">
                                                        <a class="fas fa-edit mr-1" (click)="selectPlan(Agent)"
                                                            title="Select Plan"></a>
                                                    </td>
                                                    <td class="text-right">{{i+1}}</td>
                                                    <td class="align-left">{{Agent.service}}</td>
                                                    <td class="align-left">{{Agent.currency}} {{Agent.price}}</td>
                                                    <td class="text-left">{{Agent.voice}}</td>
                                                    <td class="text-left">{{Agent.data}}</td>
                                                    <td class="text-left">{{Agent.sms}}</td>
                                                    <td class="text-left">{{Agent.validityDays}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row text-3 ml-2">
                                        Now Recharge for Australia, Austria, Belgium, Bulgaria, Canada, China, Croatia,
                                        Cyprus, Czech Republic,
                                        Denmark, Estonia, Finland, France, Georgia, Germany, Greece, Hong Kong, Hungary,
                                        Iceland, Indonesia,
                                        Ireland, Italy, Latvia, Liechtenstein, Lithuania, Luxembourg, Malaysia, Malta,
                                        Mexico, Myanmar,
                                        Netherlands, New Zealand, Norway, Poland, Portugal, Romania, Russian Federation,
                                        Singapore, Slovakia,
                                        Slovenia, South Africa, South Korea, Spain, Sri Lanka, Sweden, Switzerland,
                                        Thailand, United Kingdom ,
                                        United States, Viet Nam
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-5 shadow-md contact-information rounded">
                                    <div class="form-row">
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Plan : </label>
                                            <br /><span><b>{{activationBundle.profile}}</b></span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Service Type : </label>
                                            <br /><span>{{activationBundle.serviceType}}</span>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <label>Service : </label> <br /><span>{{activationBundle.service}}</span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Voice : </label> <span><b>{{activationBundle.voice}}</b></span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Data : </label> <span><b>{{activationBundle.data}}</b></span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>SMS : </label> <span><b>{{activationBundle.sms}}</b></span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Validity Days : </label>
                                            <span><b>{{activationBundle.validityDays}}</b></span>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group"
                                            *ngIf="activationBundle.otherBenefits!='0'">
                                            <label>Other Benefits : </label>
                                            <br /><span>{{activationBundle.otherBenefits}}</span>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <label>Remarks : </label> <br /><span>{{activationBundle.remarks}}</span>
                                        </div>
                                        <!-- <div class="col-md-6 col-lg-6 form-group">
                                            <input class="form-control" data-bv-field="text" name="activationplan"
                                                [(ngModel)]="activationplan" id="activationplan" ng-required="true"
                                                placeholder="Activation Plan" type="text" readonly>
                                        </div> -->
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <select class="form-control ng-untouched ng-pristine ng-invalid"
                                                [(ngModel)]="sim" name="sim" required="true">
                                                <option [selected]="true" value="">SIM Sub-type</option>
                                                <option value="Physical">Physical</option>
                                                <option value="eSIM">eSIM</option>
                                            </select>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <div class="autocomplete" *ngIf="sim=='eSIM'">
                                                <input type="text" class="form-control" name="simNo"
                                                    (click)="makeItBlank($event)" [(ngModel)]="simNo"
                                                    placeholder="SIM starts with 893" (keyup)="getsimNos($event)"
                                                    autocomplete="off">
                                                <div id="autocomplete-list"
                                                    class="autocomplete-items autocomplete-item text-left">
                                                    <div *ngFor="let RName of availableSIMS;"
                                                        (click)="setSimNo(RName.sim)">
                                                        <strong>{{RName.sim}}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="autocomplete" *ngIf="sim=='Physical'">
                                                <input class="form-control" name="simNo" [(ngModel)]="simNo" id="simNo"
                                                    ng-required="true" placeholder="SIM NO" type="text"
                                                    autocomplete="off" (keypress)="numberOnly($event)">
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <input class="form-control" name="firstname" [(ngModel)]="firstname"
                                                id="firstname" ng-required="true" placeholder="First name" type="text"
                                                autocomplete="off">
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <input class="form-control" name="lastname" [(ngModel)]="lastname"
                                                id="lastname" ng-required="true" placeholder="Last name" type="text"
                                                autocomplete="off">
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <input class="form-control" name="address1" [(ngModel)]="address1"
                                                id="address1" ng-required="true" placeholder="Address line 1"
                                                type="text" autocomplete="off">
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <input class="form-control" name="address2" [(ngModel)]="address2"
                                                id="address2" ng-required="true" placeholder="Address line 2"
                                                type="text" autocomplete="off">
                                        </div>
                                        <div class="col-md-4 col-lg-4 form-group">
                                            <input class="form-control" name="state" [(ngModel)]="state" id="state"
                                                ng-required="true" placeholder="State / Province" type="text"
                                                autocomplete="off">
                                        </div>
                                        <div class="col-md-4 col-lg-4 form-group">
                                            <input class="form-control" name="postalcode" [(ngModel)]="postalcode"
                                                id="postalcode" ng-required="true" placeholder="Postal Code" type="text"
                                                autocomplete="off">
                                        </div>
                                        <div class="col-md-4 col-lg-4 form-group">
                                            <input class="form-control" name="passport" [(ngModel)]="passport"
                                                id="passport" ng-required="true" placeholder="Passport Number"
                                                type="text" autocomplete="off">
                                        </div>
                                        <div class="col-md-4 col-lg-4 form-group">
                                            <input type="text" class="form-control" [options]="options"
                                                [(ngModel)]="traveldate" name="traveldate" required
                                                placeholder="Activation Date" id="flightDepart" daterangepicker>
                                            <span class="icon-inside1"><i class="far fa-calendar-alt"></i></span>
                                        </div>
                                        <div class="col-md-4 col-lg-4 form-group">
                                            <input class="form-control" name="refcode" [(ngModel)]="refcode"
                                                id="refcode" ng-required="true" placeholder="Reference Code" type="text"
                                                autocomplete="off">
                                        </div>
                                        <div class="col-md-4 col-lg-4 form-group">
                                            <input class="form-control" name="altmobile" [(ngModel)]="altmobile"
                                                id="altmobile" ng-required="true" placeholder="Alternate Mobile"
                                                type="text" autocomplete="off" (keypress)="numberOnly($event)">
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <input class="form-control" name="email" [(ngModel)]="email" id="email"
                                                ng-required="true" placeholder="Email" type="text" autocomplete="off">
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <input class="form-control" name="amount" [(ngModel)]="amount" id="amount"
                                                ng-required="true" placeholder="Amount" (keypress)="numberOnly($event)"
                                                type="amount" autocomplete="off" readonly>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <span class="text-1 col-md-7 col-lg-7">Valid Visa Proof
                                                (jpeg/jpg/png/pdf)</span>
                                            <input type="file" name="visaimage" (change)="readLogoFile($event, 'visa')"
                                                class="text-1 col-md-5 col-lg-5" />
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <span class="text-1 col-md-7 col-lg-7">Passport Front Page
                                                (jpeg/jpg/png/pdf)</span>
                                            <input type="file" name="passportimage"
                                                (change)="readLogoFile($event, 'passport')"
                                                class="text-1 col-md-5 col-lg-5" />
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <span class="text-1 col-md-7 col-lg-7">Ticket (jpeg/jpg/png/pdf)</span>
                                            <input type="file" name="ticketimage"
                                                (change)="readLogoFile($event, 'ticket')"
                                                class="text-1 col-md-5 col-lg-5" />
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <span *ngIf="paymentInitiate==''">
                                                <button class="btn btn-primary btn-block" target="_top"
                                                    (click)="ProceedActivation($event)" type="submit">Activate
                                                    SIM</button>
                                            </span>
                                            <span *ngIf="paymentInitiate!=''" class="text-5">Please
                                                wait while activation in process ..
                                                <i class="fas fa-spinner fa-pulse"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- </form> -->
                            </div>
                        </div>
                        <div class="tab-pane fade" id="second" role="tabpanel" aria-labelledby="second-tab">
                            <div class="white row">
                                <div class="col-md-7 col-sm-7">
                                    <div class="col-md-12 col-sm-12 row">
                                        <div class=" col-md-6 col-sm-6  mb-2 ">
                                            <button class="btn btn-primary btn-block"
                                                (click)="rechargePlanData('call')">Talktime, Data, SMS</button>
                                        </div>
                                        <div class=" col-md-6 col-sm-6  mb-2"><button class="btn btn-primary btn-block"
                                                (click)="rechargePlanData('data')">Data
                                                Only </button></div>
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-5"></div>
                            </div>

                            <div class="white row">
                                <!-- <form id="RechargeOnline" method="post" autocomplete="off"> -->
                                <div class="col-md-7 col-sm-7">
                                    <div id="ActivationPlanList" class="table-responsive-md">
                                        <table class="table table-hover border">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="text-right">Sel</th>
                                                    <th>SNo</th>
                                                    <th>Details</th>
                                                    <th>Amt</th>
                                                    <th>Voice</th>
                                                    <th>Data </th>
                                                    <th>SMS</th>
                                                    <th>Validity</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let Agent of rechargelist;let i = index">
                                                    <td class="text-right red hand">
                                                        <a class="fas fa-edit mr-1" (click)="selectPlanRecharge(Agent)"
                                                            title="Select Plan"></a>
                                                    </td>
                                                    <td class="text-right">{{i+1}}</td>
                                                    <td class="align-left">{{Agent.service}}</td>
                                                    <td class="align-left">{{Agent.price}}</td>
                                                    <td class="text-left">{{Agent.voice}}</td>
                                                    <td class="text-left">{{Agent.data}}</td>
                                                    <td class="text-left">{{Agent.sms}}</td>
                                                    <td class="text-left">{{Agent.validityDays}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row text-3 ml-2">
                                        Now Recharge for Australia, Austria, Belgium, Bulgaria, Canada, China, Croatia,
                                        Cyprus, Czech Republic,
                                        Denmark, Estonia, Finland, France, Georgia, Germany, Greece, Hong Kong, Hungary,
                                        Iceland, Indonesia,
                                        Ireland, Italy, Latvia, Liechtenstein, Lithuania, Luxembourg, Malaysia, Malta,
                                        Mexico, Myanmar,
                                        Netherlands, New Zealand, Norway, Poland, Portugal, Romania, Russian Federation,
                                        Singapore, Slovakia,
                                        Slovenia, South Africa, South Korea, Spain, Sri Lanka, Sweden, Switzerland,
                                        Thailand, United Kingdom ,
                                        United States, Viet Nam
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-5">
                                    <div class="form-row">
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <input class="form-control" name="mobile" [(ngModel)]="mobile" id="mobile"
                                                ng-required="true" placeholder="Mobile Number" type="text"
                                                autocomplete="off" maxlength="12" minlength="12"
                                                (keypress)="numberOnly($event)">
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Plan : </label> <br /><span>{{rechargeBundle.profile}}</span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Service Type : </label>
                                            <br /><span>{{rechargeBundle.serviceType}}</span>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <label>Service : </label> <br /><span>{{rechargeBundle.service}}</span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Voice : </label> <br /><span>{{rechargeBundle.voice}}</span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Data : </label> <br /><span>{{rechargeBundle.data}}</span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>SMS : </label> <br /><span>{{rechargeBundle.sms}}</span>
                                        </div>
                                        <div class="col-md-6 col-lg-6 form-group">
                                            <label>Validity Days : </label>
                                            <br /><span>{{rechargeBundle.validityDays}}</span>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group"
                                            *ngIf="rechargeBundle.otherBenefits!='0'">
                                            <label>Other Benefits : </label>
                                            <br /><span>{{rechargeBundle.otherBenefits}}</span>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <label>Remarks : </label> <br /><span>{{rechargeBundle.remarks}}</span>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <label>Recharge Amount : </label>
                                            <br /><span>{{rechargeBundle.currency}}
                                                {{rechargeBundle.price}}</span>
                                        </div>
                                        <div class="col-md-12 col-lg-12 form-group">
                                            <span *ngIf="paymentInitiate==''">
                                                <button class="btn btn-primary btn-block" target="_top"
                                                    (click)="ProceedRecharge($event)" type="submit">Recharge</button>
                                            </span>
                                            <span *ngIf="paymentInitiate!=''" class="text-5">Please
                                                wait while recharge in process ..
                                                <i class="fas fa-spinner fa-pulse"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- </form> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>

<!-- Modal Dialog - Login/Signup end -->